
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1200 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#F2A800","d":"M0 0h1200v600H0z"}}),_c('path',{attrs:{"fill":"#0033A0","d":"M0 0h1200v400H0z"}}),_c('path',{attrs:{"fill":"#D90012","d":"M0 0h1200v200H0z"}})])
          )
        }
      }
    